export default class BaseAssetsCollection extends Backbone.Collection
  descending: false

  initialize: ->
    @comparator = @allComparators.title
    @listenTo(this, "sync", @sort)

  allComparators:
    title: (asset) ->
      (asset.get("title") || "").toLowerCase()
    dimensions: (asset) ->
      (asset.get("width") || 0) * (asset.get("height") || 0)

  sortByColumn: (options) ->
    if @allComparators[options.column] == @comparator
      @_toggleDescending()
    else
      @comparator = @allComparators[options.column]
      @descending = false
    @sort()
    @models.reverse() if @descending

  _toggleDescending: ->
    @descending = !@descending



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/collections/assets/base_assets_collection.js.coffee